// extracted by mini-css-extract-plugin
module.exports = {"heading":"PersonalSkills_heading__3-nde"};